// src/wizard/questions.js
export const questions = [
  {
    key: "mountType",
    question: "設置場所は？",
    image: "/images/calling.png",
    subtitle: "設置する環境に合うかどか",
    description:
      "屋外に設置する場合は、耐久性や防水性能のあるモデルが必要です。屋内外用モデルもあり、柔軟に対応できます。ATMや車載など特殊な環境の場合は、専用モデルが必要になります。また、塩害地域に防犯カメラを設置する場合、潮風による腐食に耐えられるカメラを選ぶ必要があります。",
    uncertain:
      "「とりあえず建物の外に置く」なら屋外対応のものを選ぶのが安全です。迷ったら「屋内外両用」や「こだわらない」もOKです。",
    options: [
      "屋内",
      "屋外",
      "塩害地域",
      "屋内外両用",
      "特殊用途（ATM・車載など）",
      "こだわらない",
    ],
  },

  {
    key: "buildingType",
    question: "設置したい建物の種類は？",
    image: "/images/building.png",
    subtitle: "現地調査や施工方法の確認に使います",
    description:
      "設置する建物の種類によって、配線ルート・取付位置・共用部の確認・管理会社への確認など、現地調査で見るべきポイントが変わります。",
    uncertain: "迷う場合は、近いものを選んでください。判断が難しい場合は「その他」でもOKです。",
    options: [
      { label: "戸建て", value: "戸建て" },
      { label: "マンション", value: "マンション" },
      { label: "ビル", value: "ビル" },
      { label: "その他", value: "その他" },
    ],
  },
  {
    key: "connectivity",
    question: "設置場所のインターネット状況は？",
    image: "/images/network.png",
    subtitle: "カメラをどのようにネットや録画機器につなぐか",
    description:
      "通信方法には「LAN（有線）」と「Wi-Fi（無線）」があり、それぞれに特徴があります。LAN接続は通信が安定しやすく重要な場面の録画にも安心ですが、配線工事が必要になる場合があります。一方Wi-Fi接続は配線不要で設置が簡単な反面、天候や建物の環境によって通信が不安定になることもあり、映像が途切れたり遅れることがあります。既に業務用の録画機器がある場合などには、アナログ接続が使われることもあります。",
    uncertain:
      "ネット回線がある場所なら「有線」や「Wi-Fi」が使いやすくておすすめです。今あるカメラ配線を使いたい場合は、既存機器に対応できるか確認が必要です。設置場所の状況が不明な場合は、別途お問い合わせいただければ確認できます。",
    options: [
      { label: "有線でつなげられる", value: "LANケーブル" },
      { label: "Wi-Fiが使える", value: "Wi-Fi" },
      { label: "今のカメラ配線を使いたい", value: "アナログ" },
      { label: "わからない／こだわらない", value: "こだわらない" },
    ],
  },
  {
    key: "recordingMethod",
    question: "録画した映像はどこに残しますか？",
    image: "/images/decision.png",
    subtitle: "映像をどこに・どうやって保存するか",
    description:
      "SDカード:カメラ本体に直接記録。電源さえあれば使え、設置が手軽。容量や寿命には注意。クラウド:映像をインターネット経由で保存。遠隔から確認でき、機器が壊れてもデータが残る。NAS/NVR:複数台の映像を一括で管理。設置や設定に少し専門知識がいるが、拡張性が高い。",
    uncertain:
      "クラウドでの保存が、容量不足による録画漏れがなく、動画の確認を離れた場所でもできるのでおすすめです。",
    options: [
      { label: "カメラ本体に保存したい", value: "SDカード" },
      { label: "ネット上に保存したい", value: "クラウド" },
      { label: "録画機にまとめて保存したい", value: "NAS / NVR" },
      { label: "今の録画機を使いたい", value: "DVR（同軸）" },
      { label: "わからない／こだわらない", value: "こだわらない" },
    ],
  },

  {
    key: "lensType",
    question: "撮影範囲は？",
    image: "/images/smartphone-data.png",
    subtitle: "撮る範囲と距離で決める",
    description:
      "広く映したいなら広角、人や顔をはっきり映したいなら標準、遠くを狙いたいなら望遠が適しています。",
    uncertain:
      "なるべく多くの範囲を1台で映したいなら「広い範囲」、防犯や顔確認を重視するなら「人や顔をちゃんと映したい」がおすすめです。",
    options: [
      "広い範囲を撮りたい",
      "人や顔をちゃんと映したい",
      "ズームして遠くを見たい",
      "こだわらない",
    ],
  },

  {
    key: "waterproofDustproof",
    question: "防水防塵機能は？",
    image: "/images/rain.png",
    subtitle: "雨やホコリに強い必要があるかどうか",
    description:
      "屋外や粉じんの多い場所に設置する場合は、防水・防塵性能があるモデルが必要です。IP等級などで性能が示されます。",
    uncertain: "屋根のない屋外に置く予定があるなら「有り」を選ぶのが安全です。",
    options: ["有り", "無し", "こだわらない"],
  },

  {
    key: "resolution",
    question: "画質は？",
    image: "/images/quality.png",
    subtitle: "どれだけ細かく映したいか",
    description:
      "高画質（8MP〜）は顔の表情までくっきり映せますが、データ容量は多くなります。普通（5MP前後）は防犯目的に十分、最低限（2MP前後）はコスト優先に向いています。",
    uncertain:
      "映像の確認や証拠として使いたいなら「はっきり」。価格や保存のしやすさを重視するなら「普通」か「最低限」がおすすめです。",
    options: ["はっきり", "普通", "最低限", "こだわらない"],
  },

  {
    key: "lowLightPerformance",
    question: "暗所撮影性能は？",
    image: "/images/dream.png",
    subtitle: "夜や暗い場所でも映す必要があるか",
    description:
      "赤外線やスターライトなどの技術で、照明のない夜間でも映像が残せます。夜間の監視や無人の場所に設置する場合は有効です。",
    uncertain: "夜も確認したいなら「有り」を選ぶのがおすすめです。",
    options: ["有り", "無し", "こだわらない"],
  },

  {
    key: "aiFeatures",
    question: "AI機能は？",
    image: "/images/artificial-intelligence.png",
    subtitle: "防犯カメラに“基本以上”の役割を求めるかどうか",
    description:
      "AI機能があると、人や車をカメラが自動で見分け、必要なときだけ録画や通知をしてくれます。何があったかをあとから探す手間を減らす、あるいは起きた瞬間をすぐ知るといった使い方が可能です。一方で、常に録画されていれば十分という目的であれば、AI機能はなくても問題ありません。AIは「ただ録画する」以上の使い方をしたい人に向いています。",
    uncertain:
      "AI機能は、「誰か来たときにすぐ知りたい」「映像をあとから見返すのが面倒」という方におすすめです。とりあえず録画ができれば十分という場合は、AIなしでも問題ありません。",
    options: ["有り", "無し", "こだわらない"],
  },
];
